import * as type from '../ActionTypes';

export function getJobs(params: any) {
  return {
    type: type.GET_JOB_REQUEST,
    params: params
  };
}
export function getClientInfoByJobPostInit() {
  return {
    type: type.GET_JOB_REQUEST_INIT
  };
}
export function getClientInfoByJobPostRequest(params: any) {
  return {
    type: type.GET_CLIENTINFO_BY_JOBPOST_REQUEST,
    params: params
  };
}

export function getClientInfoByLatestJobPostRequest(params: any) {
  return {
    type: type.GET_LATEST_JOB_REQUEST,
    params: params
  };
}

export function getJobById(jobId: string) {
  return {
    type: type.GET_JOB_REQUEST_BY_ID,
    id: jobId
  };
}

export function getJobByIdSucess(jobDetails: any) {
  return {
    type: type.GET_JOB_SUCCESS_BY_ID,
    payload: jobDetails
  };
}

export function getJobByIdFailure(error: any) {
  return {
    type: type.GET_JOB_FAILURE_BY_ID,
    payload: error
  };
}

export function setJobProposal(data: any) {
  return {
    type: type.SET_JOB_PROPOSAL,
    data: data
  };
}

export function setJobFavourite(data: any) {
  return {
    type: type.SET_JOB_FAVOURITE,
    data: data
  };
}

export function clearJobDetails() {
  return {
    type: type.CLEAR_JOB_DETAILS
  };
}

export function resetJobsData() {
  return {
    type: type.RESET_JOBS
  };
}

export function getRecommendedCoderJobPost(params: any) {
  return {
    type: type.GET_RECOMMENDEDCODER_REQUEST,
    params
  };
}

export function getInvitedCoderJobPost(params: any) {
  return {
    type: type.GET_INVITEDCODER_REQUEST,
    params: params
  };
}
export function patchInvitedCoderJobPost(params: any) {
  return {
    type: type.PATCH_INVITEDCODER_REQUEST,
    params: params
  };
}

export function clearInvitationError() {
  return {
    type: type.CLEAR_INVITE_ERROR
  };
}

export function getAllJobRouteCount(params: any) {
  return {
    type: type.GET_ROUTE_COUNT_REQUEST,
    params: params
  };
}
export function resetAllJobRouteCount() {
  return {
    type: type.RESET_ROUTE_COUNT
  };
}

export function clearLatestJobs() {
  return {
    type: type.CLEAR_LATEST_JOB_REQUEST
  };
}

export function clearRecommendedJobs() {
  return {
    type: type.CLEAR_RECOMMENDED_JOBS
  };
}

export function getClientInviteJob() {
  return {
    type: type.GET_CLIENT_INVITE_JOB_REQUEST
  };
}
